import { useRef } from 'react';
import { pluralize } from '@utils/common';
import { stringifyGradeLevelRange } from '@utils/constants';
import { useKatex, PostloadedImage } from '@utils/react';
import { CardLink } from '../../atoms/card-link.js';
import { wrapperCls, imageAndMetaWrapperCls, imageCls, metaItemCls, titleCls, descriptionCls, buttonCls } from './atom.card-overlay.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CardOverlay(props) {
  const headingRef = useRef(null);
  const descriptionRef = useRef(null);
  const labelId = `${props.card.title}-label`;
  useKatex(headingRef);
  useKatex(descriptionRef);
  return /*#__PURE__*/jsxs(CardLink, {
    ref: props.ref,
    hostname: props.card.link.portal.hostname,
    path: props.card.link.path,
    className: wrapperCls,
    "aria-labelledby": labelId,
    children: [/*#__PURE__*/jsxs("div", {
      className: imageAndMetaWrapperCls,
      children: [/*#__PURE__*/jsx(PostloadedImage, {
        className: imageCls,
        src: props.card.imageSrc,
        sizes: "100px",
        alt: ""
      }), /*#__PURE__*/jsxs("ul", {
        "aria-hidden": true,
        children: [!!props.card.meta.courseCount && /*#__PURE__*/jsxs("li", {
          className: metaItemCls,
          children: ["Ca. ", props.card.meta.courseCount, " ", pluralize("lektion", props.card.meta.courseCount)]
        }), /*#__PURE__*/jsx("li", {
          className: metaItemCls,
          children: stringifyGradeLevelRange(props.card.meta.grades)
        })]
      })]
    }), /*#__PURE__*/jsx("h3", {
      ref: headingRef,
      className: titleCls,
      "aria-hidden": true,
      children: props.card.title
    }), /*#__PURE__*/jsx("p", {
      ref: descriptionRef,
      className: descriptionCls,
      children: props.card.description
    }), /*#__PURE__*/jsx("div", {
      className: buttonCls,
      id: labelId,
      children: "Se indhold"
    })]
  });
}

export { CardOverlay };
//# sourceMappingURL=atom.card-overlay.js.map
